import React, { useEffect } from 'react';

import MarketingHeader from '../components/MarketingHeader';
import '../styles/MarketingTheme.css';



const CookiePolicyPage = () => {


    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="marketing-page stunning-theme">
            <MarketingHeader />

            {/* Main Content */}
            <div className="marketing-container mt-4 mb-lg">
                <div className="legal-layout">
                    {/* Sidebar Navigation */}
                    <aside className="marketing-legal-sidebar hidden md:block">
                        <div className="mb-4">
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">On this page</p>
                            <nav className="flex flex-col space-y-2">
                                <button onClick={() => scrollToSection('what')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">1. What are Cookies?</button>
                                <button onClick={() => scrollToSection('types')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">2. Types of Cookies</button>
                                <button onClick={() => scrollToSection('manage')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">3. Managing Preferences</button>
                            </nav>
                        </div>
                        <div className="mt-8 pt-6 border-t border-white/10">
                            <p className="text-xs text-gray-500 mb-2">Have questions?</p>
                            <a href="mailto:support@redsorm.in" className="text-sm text-purple-400 hover:text-purple-300 font-medium">Contact Support →</a>
                        </div>
                    </aside>

                    {/* Document Content */}
                    <article className="marketing-legal-content">
                        <div className="flex items-center gap-2 mb-8">
                            <span className="w-2 h-2 rounded-full bg-yellow-500"></span>
                            <span className="text-sm text-gray-400">Last updated: {new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                        </div>

                        <h1>Cookie Policy</h1>
                        <p className="lead text-lg text-gray-300 mb-10 border-b border-white/10 pb-8">
                            We use cookies to make your experience with RedSorm sweeter (and more functional). This policy explains how and why.
                        </p>

                        <div id="what" className="mb-12">
                            <h2>1. What are Cookies?</h2>
                            <p>Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the owners of the site.</p>
                        </div>

                        <div id="types" className="mb-12">
                            <h2>2. Types of Cookies We Use</h2>
                            <p>We use a combination of session and persistent cookies to enable the following functionality:</p>

                            <div className="space-y-4 mt-6">
                                <div className="marketing-card p-4 flex gap-5 items-start bg-white/5 border-none">
                                    <div className="w-10 h-10 flex-shrink-0 bg-white/10 rounded-full flex items-center justify-center text-gray-200">
                                        <i className="fas fa-shield-alt"></i>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-bold text-white mb-1">Essential Cookies</h3>
                                        <p className="text-sm text-gray-400 leading-relaxed">Required for the platform to work. Includes login sessions, security tokens, and load balancing.</p>
                                    </div>
                                </div>

                                <div className="marketing-card p-4 flex gap-5 items-start bg-white/5 border-none">
                                    <div className="w-10 h-10 flex-shrink-0 bg-blue-500/20 rounded-full flex items-center justify-center text-blue-400">
                                        <i className="fas fa-chart-line"></i>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-bold text-white mb-1">Analytics Cookies</h3>
                                        <p className="text-sm text-gray-400 leading-relaxed">Help us understand how you use the dashboard so we can improve workflows. These are anonymized.</p>
                                    </div>
                                </div>

                                <div className="marketing-card p-4 flex gap-5 items-start bg-white/5 border-none">
                                    <div className="w-10 h-10 flex-shrink-0 bg-purple-500/20 rounded-full flex items-center justify-center text-purple-400">
                                        <i className="fas fa-magic"></i>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-bold text-white mb-1">Preference Cookies</h3>
                                        <p className="text-sm text-gray-400 leading-relaxed">Remember your language settings, theme preferences (Dark/Light mode), and branch filters.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="manage" className="mt-12 pt-8 border-t border-white/10">
                            <h2>3. Managing Cookie Preferences</h2>
                            <p>You can change your cookie preferences at any time by changing your browser settings. Blocked cookies may prevent certain features (like logging in) from working correctly.</p>
                            <div className="mt-4">
                                <a href="https://www.cookiesandyou.com/" target="_blank" rel="noreferrer" className="text-purple-400 font-medium hover:text-purple-300">Learn more about managing cookies →</a>
                            </div>
                        </div>
                    </article>
                </div>
            </div>

            {/* Footer */}
            <footer className="marketing-footer">
                <div className="marketing-footer-content">
                    <p>&copy; {new Date().getFullYear()} RedSorm. All rights reserved.</p>
                    <div className="marketing-footer-links">
                        <a href="/terms-of-service" className="marketing-footer-link">Terms</a>
                        <a href="/privacy-policy" className="marketing-footer-link">Privacy</a>
                        <a href="/cookie-policy" className="marketing-footer-link">Cookies</a>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default CookiePolicyPage;
